<template>
  <div
    v-if="isValidated && formObserver.failed"
    id="form-errors"
    class="form-errors mt-9 pt-6"
  >
    <header class="form-errors__header">
      <form-section-label>Looks like we have a problem!</form-section-label>
      <form-section-question>
        {{ pluralize('question', failedSections.length, true) }}
        {{ failedSections.length === 1 ? 'needs' : 'need' }} your attention in order to continue to the next step
      </form-section-question>
    </header>
    <div
      v-for="section in failedSections"
      :key="section.id"
      class="form-errors__row"
    >
      <label class="form-errors__label">
        {{ section.name }}
      </label>
      <div class="form-errors__actions">
        <v-btn
          v-scroll-to="{ el: `#${section.id}` }"
          v-add-zuko-tag="`resolve_btn ${componentKey}`"
          rounded
          dark
          class="btn-resolve-error"
          color="navy-light"
          data-test="resolve_btn"
          @click.prevent
        >
          Resolve
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import pluralize from 'pluralize';
import {
  flatten,
  kebabCase,
} from 'lodash';
import {
  inject,
  computed,
} from '@vue/composition-api';

export default {
  name: 'core-step-errors',
  props: {
    isValidated: {
      type: Boolean,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    structure: {
      type: Array,
      required: true,
    },
    activeStep: {
      type: Object,
      required: true,
    },
    componentKey: {
      type: String,
      required: true,
    },
    isAdditionalDriver: {
      type: Boolean,
      default: false,
    },
    stepRef: {
      type: Object,
      default: () => {},
    },
  },
  setup (props) {
    const productName = inject('productName');

    const failedSections = computed(() => {
      const step = props.structure.find(({ stepId }) => stepId === props.activeStep.id);

      const stepSections = flatten(step.groups.map(({ sections }) => sections));

      const failedSections = stepSections
        .filter(({ fields, sectionId }) => {
          const fieldIds = fields
            .map(field => {
              if (typeof field === 'string') {
                return {
                  field: `${step.stepId}_${kebabCase(field)}`,
                  section: `${step.stepId}_${sectionId}`,
                };
              }

              if (typeof field === 'object') {
                return field.fields.map(subField => {
                  return `${step.stepId}_${field.parent}_${kebabCase(subField)}`;
                });
              }
            });
          return flatten(fieldIds).some(fieldId => {
            if (props.formObserver.fields[fieldId.field]) {
              return props.formObserver.fields[fieldId.field].failed;
            }

            if (props.formObserver.fields[fieldId.section]) {
              return props.formObserver.fields[fieldId.section].failed;
            }

            return false;
          });
        })
        .map(({ sectionId, sectionLabel, sectionLabelAdditional }) => {
          const sectionRef = props.stepRef?.$refs[sectionId];
          const dynamicTitle = productName === 'home'
            ? sectionRef?.formRowTitle
            : sectionRef?.[0]?.formRowTitle;
          const label = dynamicTitle || sectionLabel;
          const additionalLabel = dynamicTitle || sectionLabelAdditional || sectionLabel;
          return {
            id: sectionId,
            name: props.isAdditionalDriver ? additionalLabel : label,
          };
        });
      return failedSections;
    });

    return {
      pluralize,
      failedSections,
    };
  },
};
</script>
